export interface Comic {
  id: string;
  title: string;
  category: string;
  tags: string[];
  cover: string;
  author: string;
  status: "连载中" | "已完结";
  rating: number;
  views: string;
  chapters: number;
  year: string;
  short: string;
  synopsis: string;
  featured?: boolean;
}

export const comics: Comic[] = [
  {
    id: "xingyuan-biduan",
    title: "星渊彼端",
    category: "otherworld",
    tags: ["异世界", "魔法学院", "热血", "冒险"],
    cover:
      "https://readdy.ai/api/search-image?query=young%20hero%20with%20staff%20standing%20before%20a%20glowing%20star%20abyss%20portal%2C%20fantasy%20korean%20webtoon%20cover%20art%2C%20stylized%20painting%2C%20deep%20emerald%20and%20gold%20palette%2C%20simple%20ethereal%20background&width=600&height=900&seq=comic-01-xingyuan&orientation=portrait",
    author: "林雾川",
    status: "连载中",
    rating: 9.2,
    views: "3.6亿",
    chapters: 128,
    year: "2023",
    short: "少年穿越星渊大陆，在精灵与巨龙共存的魔法世界踏上旅途。",
    synopsis:
      "普通高中生陆离在一场流星雨之夜坠入星渊大陆，一个由精灵、巨龙与古老魔法构成的世界。他发现自己拥有罕见的『星辉』天赋，却被卷入两大势力关于星渊之门的争夺。面对即将吞噬世界的黑暗，陆离必须在天选之子的宿命与同伴的羁绊之间做出选择，踏上跨越七座浮空岛的冒险之旅。",
    featured: true,
  },
  {
    id: "wuguo-nvdi",
    title: "雾之国女帝",
    category: "otherworld",
    tags: ["女强", "权谋", "国战", "重生"],
    cover:
      "https://readdy.ai/api/search-image?query=regal%20empress%20in%20flowing%20robes%20overlooking%20a%20misty%20kingdom%20from%20a%20stone%20balcony%2C%20fantasy%20korean%20webtoon%20cover%20art%2C%20stylized%20painting%2C%20soft%20mist%20teal%20and%20gold%20tones&width=600&height=900&seq=comic-02-wuguo&orientation=portrait",
    author: "白露生",
    status: "连载中",
    rating: 9.0,
    views: "2.1亿",
    chapters: 96,
    year: "2024",
    short: "亡国公主重生归来，以谋略与权术重夺雾之国的王座。",
    synopsis:
      "雾之国末代公主瑟拉前世含恨而亡，一朝重生回到亡国之前。这一次，她不再天真，而是以冷冽的谋略步步为营：联合边境公爵、笼络水师将领、破解敌国谍网。在魔法与战争交织的乱世中，这位被称作『雾中女帝』的少女，将用自己的双手改写整个王国的命运。",
  },
  {
    id: "longyi-qiyuezhe",
    title: "龙裔契约者",
    category: "otherworld",
    tags: ["龙族", "契约", "战斗", "热血"],
    cover:
      "https://readdy.ai/api/search-image?query=young%20dragon%20rider%20with%20a%20sapphire%20dragon%20companion%20in%20mid-air%20over%20cloudy%20peaks%2C%20fantasy%20korean%20webtoon%20cover%20art%2C%20stylized%20painting%2C%20emerald%20sky%20and%20warm%20gold%20light&width=600&height=900&seq=comic-03-longyi&orientation=portrait",
    author: "墨白",
    status: "连载中",
    rating: 8.8,
    views: "1.7亿",
    chapters: 110,
    year: "2022",
    short: "背负龙裔血脉的少年，与失落之龙缔结契约，重返龙之谷。",
    synopsis:
      "十五年前，龙之谷一夜之间消失于天际，龙裔血脉沦为禁忌。少年艾兰在边境猎场意外唤醒一头沉眠的幼龙，由此揭开自己身世的真相。为查明龙之谷覆灭之谜，他踏上回归之路，却一次次卷入人类王国与远古龙族的恩怨。当契约之印亮起，他能守护的，远不止这一头龙。",
  },
  {
    id: "nilushi-guangdelvren",
    title: "逆流时空的旅人",
    category: "otherworld",
    tags: ["时间", "悬疑", "奇幻", "成长"],
    cover:
      "https://readdy.ai/api/search-image?query=lone%20traveler%20walking%20through%20a%20shattered%20clockwork%20time%20vortex%20with%20floating%20hourglasses%2C%20fantasy%20korean%20webtoon%20cover%20art%2C%20stylized%20painting%2C%20amber%20and%20teal%20palette&width=600&height=900&seq=comic-04-nilushi&orientation=portrait",
    author: "顾南笙",
    status: "已完结",
    rating: 9.1,
    views: "2.8亿",
    chapters: 152,
    year: "2021",
    short: "拥有时间回溯能力的旅人，在一次次逆流中改写世界的终局。",
    synopsis:
      "塔罗占卜师少女因一场预言卷入了时间乱流，得到『逆流』的能力——每一次死亡都能回到过去的某个节点。她在循环中结识了被诅咒的骑士、将陨落的贤者与沉默的精灵王。然而时间并非温顺的仆从，每轮回一次，世界线便崩塌一分。她必须找出真正的『时间之心』，在无数遗憾中找出唯一能拯救所有人的那一条路。",
  },
  {
    id: "yueguang-qiyue",
    title: "月光契约",
    category: "elf",
    tags: ["精灵", "契约", "治愈", "甜恋"],
    cover:
      "https://readdy.ai/api/search-image?query=elf%20girl%20with%20luminous%20wings%20under%20a%20full%20moon%20among%20glowing%20flowers%2C%20fantasy%20korean%20webtoon%20cover%20art%2C%20stylized%20painting%2C%20moonlit%20silver%20and%20soft%20emerald%20tones&width=600&height=900&seq=comic-05-yueguang&orientation=portrait",
    author: "夜阑珊",
    status: "连载中",
    rating: 9.4,
    views: "4.2亿",
    chapters: 88,
    year: "2024",
    short: "人类少女与月光精灵缔结契约，在满月之下共享命运的羁绊。",
    synopsis:
      "每逢满月，圣树便会降下月光精灵。濒临衰亡的精灵一族，需要与人类缔结『月光契约』才能延续生命。胆小怕生的少女苏晚在一次意外中唤醒了精灵王子夜凛，两人被迫共享记忆与痛觉。一个是寻找失踪王兄的王子，一个是渴望自由的少女——这场契约，究竟是诅咒，还是命运赠予彼此的礼物？",
    featured: true,
  },
  {
    id: "senzhi-shouhuling",
    title: "森之守护灵",
    category: "elf",
    tags: ["治愈", "自然", "守护", "奇幻"],
    cover:
      "https://readdy.ai/api/search-image?query=gentle%20forest%20guardian%20spirit%20with%20moss%20and%20leaves%20holding%20a%20young%20seedling%2C%20fantasy%20korean%20webtoon%20cover%20art%2C%20stylized%20painting%2C%20verdant%20green%20and%20warm%20gold%20light&width=600&height=900&seq=comic-06-senzhi&orientation=portrait",
    author: "青梧",
    status: "连载中",
    rating: 8.7,
    views: "9800万",
    chapters: 74,
    year: "2023",
    short: "觉醒的森之守护灵，与迷路的少女一同守护濒临枯竭的森林。",
    synopsis:
      "古老的精灵林因人类过度开垦而逐渐枯萎，蛰伏百年的森之守护灵『椋』被迫苏醒。它意外发现少女阿树竟能听懂植物低语，便与她缔结守护契约。一人一灵踏上修复森林的旅程，沿途对抗侵蚀自然的『蚀雾』，也一次次直面人与精灵千百年来的误解与仇恨。",
  },
  {
    id: "fengyu-jingling",
    title: "风语精灵",
    category: "elf",
    tags: ["冒险", "风元素", "学院", "伙伴"],
    cover:
      "https://readdy.ai/api/search-image?query=sprightly%20wind%20elf%20girl%20dancing%20with%20swirling%20breeze%20and%20feathers%20in%20an%20open%20sky%2C%20fantasy%20korean%20webtoon%20cover%20art%2C%20stylized%20painting%2C%20airy%20turquoise%20and%20cream%20palette&width=600&height=900&seq=comic-07-fengyu&orientation=portrait",
    author: "叶听雨",
    status: "连载中",
    rating: 8.6,
    views: "7600万",
    chapters: 82,
    year: "2024",
    short: "能听懂风声的精灵少女，与沉默的骑士踏上寻找失语之城的旅途。",
    synopsis:
      "风元素精灵一族世代守护着『失语之城』的秘密。少女风吟因能听见风的低语，被视为被诅咒的存在。当城中的声音开始消失，她与奉命追查的沉默骑士结成临时同伴，循着风留下的线索穿越山川与荒漠。风声指引的尽头，埋藏着精灵一族失落千年的真相。",
  },
  {
    id: "qiannian-qiyue-xinniang",
    title: "千年契约新娘",
    category: "elf",
    tags: ["奇幻", "甜恋", "契约", "命运"],
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20elf%20bride%20in%20silver%20ceremonial%20robe%20with%20ancient%20contract%20scroll%20and%20starlight%2C%20fantasy%20korean%20webtoon%20cover%20art%2C%20stylized%20painting%2C%20ivory%20and%20emerald%20tones&width=600&height=900&seq=comic-08-qiannian&orientation=portrait",
    author: "苏瑾",
    status: "已完结",
    rating: 8.9,
    views: "1.5亿",
    chapters: 120,
    year: "2022",
    short: "被迫替嫁的少女，与跨越千年的契约结下不解之缘。",
    synopsis:
      "圣树的预言每隔千年便会选中一位『契约新娘』，与精灵王缔结婚姻以延续两界和平。平凡少女姜念被卷入这场盛大的宿命，却发现精灵王看似冷淡的契约背后，隐藏着一份跨越千年的执念。当千年之约的真相逐渐浮现，这份被时间染上尘埃的约定，是否还能开出新的花朵？",
  },
  {
    id: "huyao-yexing",
    title: "狐妖夜行",
    category: "myth",
    tags: ["九尾狐", "都市", "神话", "虐恋"],
    cover:
      "https://readdy.ai/api/search-image?query=nine%20tailed%20fox%20spirit%20with%20glowing%20eyes%20walking%20a%20rainy%20neon%20street%2C%20mythical%20korean%20webtoon%20cover%20art%2C%20stylized%20ink%20painting%20fusion%2C%20crimson%20and%20jade%20tones&width=600&height=900&seq=comic-09-huyao&orientation=portrait",
    author: "宴无归",
    status: "连载中",
    rating: 9.3,
    views: "5.0亿",
    chapters: 143,
    year: "2023",
    short: "蛰伏都市五百年的九尾狐，在霓虹之下追寻遗落的妖心。",
    synopsis:
      "五百年前，九尾狐白九因一场人妖之恋遗失了最重要的『妖心』，自此在人间游荡。如今她是都市里一名冷艳的占卜师，每逢月圆之夜便外出收集人类的故事碎片。当旧日仇敌重现，一个关于心、执念与轮回的真相，正随着她的第九条尾巴逐渐苏醒。",
    featured: true,
  },
  {
    id: "shangui-wuyu",
    title: "山鬼物语",
    category: "myth",
    tags: ["山神", "治愈", "东方", "志怪"],
    cover:
      "https://readdy.ai/api/search-image?query=mountain%20spirit%20woman%20with%20flower%20crown%20among%20misty%20peaks%20and%20ancient%20shrines%2C%20mythical%20korean%20webtoon%20cover%20art%2C%20stylized%20ink%20painting%20fusion%2C%20misty%20jade%20and%20rose%20tones&width=600&height=900&seq=comic-10-shangui&orientation=portrait",
    author: "云之杳",
    status: "已完结",
    rating: 8.8,
    views: "1.1亿",
    chapters: 104,
    year: "2021",
    short: "守护深山的山鬼，与误入山林的凡人结下跨越生死的缘分。",
    synopsis:
      "深山老林之中住着一位守护山林的山鬼，她以花为冠、以露为食，收集山中所有生灵的祈愿。误入山林的年轻画家为寻找灵感与她相遇，两人在山间四季的更迭中渐生情愫。然而山鬼的宿命是守护而非停留，当山神的试炼降临，这段人鬼之恋能否冲破生死与规则？",
  },
  {
    id: "longgong-yetan",
    title: "龙宫夜谭",
    category: "myth",
    tags: ["龙族", "海洋", "神话", "权谋"],
    cover:
      "https://readdy.ai/api/search-image?query=underwater%20dragon%20palace%20with%20glowing%20pearls%20and%20a%20dragon%20prince%20among%20coral%20ruins%2C%20mythical%20korean%20webtoon%20cover%20art%2C%20stylized%20ink%20painting%20fusion%2C%20deep%20teal%20and%20gold%20tones&width=600&height=900&seq=comic-11-longgong&orientation=portrait",
    author: "沧浪生",
    status: "连载中",
    rating: 8.5,
    views: "6400万",
    chapters: 67,
    year: "2024",
    short: "没落龙宫的少年太子，与人类少女携手重振龙族荣光。",
    synopsis:
      "龙宫败落，四海失序，幼年太子敖溯被贬为凡人流落海边渔村。他在这里结识了能听懂龙语的人类少女小满，两人凭借半本失传的龙宫古籍，踏上寻回四大神珠、重振龙族的旅途。深海之下，沉睡的旧臣、暗涌的阴谋与一段尘封的龙族往事正缓缓浮现。",
  },
  {
    id: "baiyao-lu",
    title: "百妖录",
    category: "myth",
    tags: ["群像", "志怪", "单元剧", "神话"],
    cover:
      "https://readdy.ai/api/search-image?query=open%20ancient%20bestiary%20book%20with%20glowing%20spirits%20escaping%20its%20pages%2C%20mythical%20korean%20webtoon%20cover%20art%2C%20stylized%20ink%20painting%20fusion%2C%20warm%20amber%20and%20ink%20black%20tones&width=600&height=900&seq=comic-12-baiyao&orientation=portrait",
    author: "拾遗者",
    status: "连载中",
    rating: 9.1,
    views: "2.3亿",
    chapters: 178,
    year: "2022",
    short: "一本百妖录，百个妖与人之间的恩怨情仇单元故事。",
    synopsis:
      "神秘的收妖人行走世间，手中的《百妖录》封印着千百年来横行人间的妖怪。每一页被重新点亮，便是一个妖与人纠缠的往事——有情深不悔的狐妖、有执念难消的山鬼、有守护一方的河神。这部志怪群像作品以单元剧形式，讲述东方神话里那些妖与人之间，或温情、或苍凉的故事。",
  },
];

export const getComic = (id: string) => comics.find((c) => c.id === id);

export const comicsByCategory = (slug: string) => comics.filter((c) => c.category === slug);

export const featuredComics = comics.filter((c) => c.featured);

export const hotComics = [...comics].sort((a, b) => Number(b.views.replace("万", "0000").replace("亿", "00000000")) - Number(a.views.replace("万", "0000").replace("亿", "00000000")));